import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule, MatIconModule, MatTooltipModule } from '@angular/material';
import { TranslateModule } from '@ngx-translate/core';
import { InsertPasswordComponent } from './insert-password.component';

@NgModule({
  declarations: [
    InsertPasswordComponent
  ],
  imports: [
    FormsModule,
    CommonModule,
    TranslateModule,
    MatButtonModule,
    ReactiveFormsModule,
    MatTooltipModule,
    MatIconModule,
  ],
  exports: [
    InsertPasswordComponent
  ]
})
export class InsertPasswordModule { }
